export const isAppspool = window.location.hostname.includes('appspool')
//  || window.location.hostname.includes('localhost')
 ? true : false


// WEBPACK FOOTER //
// ./src/constants/isAppspool.js